module.exports = __webpack_public_path__ + "static/img/text-image-1.d9109b0d.png";